<template>
    <div class="not-found-container container fade-in">
        <div class="not-found-content card">
            <div class="error-code">404</div>
            <h1>{{ $t('notFound.title') }}</h1>
            <p>{{ $t('notFound.message') }}</p>
            <div class="avatar-placeholder">
                <!-- We could add a randomly generated avatar here -->
                <svg viewBox="-50 -50 100 100" width="150" height="150">
                    <circle cx="0" cy="0" r="45" fill="#f8d7da" />
                    <circle cx="-15" cy="-10" r="5" fill="white" stroke="black" stroke-width="1.5" />
                    <circle cx="15" cy="-10" r="5" fill="white" stroke="black" stroke-width="1.5" />
                    <path d="M -20,20 Q 0,0 20,20" stroke="black" fill="none" stroke-width="2" />
                </svg>
            </div>
            <div class="buttons-container">
                <router-link to="/" class="btn btn-primary">{{ $t('notFound.goHome') }}</router-link>
                <router-link to="/generator" class="btn btn-secondary">{{ $t('notFound.createAvatar') }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
    name: 'NotFound',
    setup() {
        const { t } = useI18n()
        return { t }
    },
    metaInfo() {
        return {
            title: this.t('notFound.title') + ' - Ugly Avatar',
        }
    }
}
</script>

<style scoped>
.not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80vh;
    padding: 2rem;
}

.not-found-content {
    max-width: 500px;
    text-align: center;
    padding: 3rem 2rem;
}

.error-code {
    font-size: 6rem;
    font-weight: 800;
    color: #f8d7da;
    line-height: 1;
    margin-bottom: 0.5rem;
    text-shadow: 3px 3px 0 #e74c3c;
}

h1 {
    font-size: 2rem;
    color: var(--secondary-color);
    margin-bottom: 1rem;
}

p {
    color: var(--text-secondary);
    margin-bottom: 2rem;
    font-size: 1.1rem;
}

.avatar-placeholder {
    margin: 2rem 0;
    animation: float 3s ease-in-out infinite;
}

.buttons-container {
    display: flex;
    justify-content: center;
    gap: 1rem;
}

@keyframes float {
    0% {
        transform: translateY(0px);
    }

    50% {
        transform: translateY(-10px);
    }

    100% {
        transform: translateY(0px);
    }
}

@media (max-width: 500px) {
    .error-code {
        font-size: 4rem;
    }

    h1 {
        font-size: 1.75rem;
    }

    .buttons-container {
        flex-direction: column;
    }

    .btn {
        width: 100%;
    }
}
</style>